import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../services/api';
import { isWebPushConfigured, registerWebPush } from './webPush';

const LABELS = {
  licenca_alerts_enabled: ['Licenças', 'Vencimento, emissão e alertas de licença'],
  condicionante_enabled: ['Condicionantes', 'Prazos de condicionantes'],
  processo_enabled: ['Processos', 'Protocolo, conclusão e processos parados'],
  denuncia_enabled: ['Denúncias e fiscalização', 'Denúncias, vistorias e autos'],
  legislacao_enabled: ['Análise normativa', 'Quando a análise de legislação terminar'],
  security_enabled: ['Segurança da conta', 'Alteração de senha'],
  billing_enabled: ['Cobrança e assinatura', 'Fatura, atraso e suspensão'],
};

export default function PushPreferencesPanel() {
  const { t } = useTranslation(['notifications']);
  const [ready, setReady] = useState(false);
  const [categories, setCategories] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const result = await registerWebPush();
      if (cancelled) return;
      setReady(Boolean(result.ready));
      try {
        const { data } = await api.get('/api/v1/devices/me/preferences');
        if (!cancelled) setCategories(data?.categories || null);
      } catch {
        if (!cancelled) setCategories(null);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const toggle = async (key, value) => {
    const next = { ...(categories || {}), [key]: value };
    setCategories(next);
    setBusy(true);
    try {
      await api.patch('/api/v1/devices/me/preferences', { categories: next });
    } catch {
      setCategories(categories);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-4">
      <div>
        <h4 className="mb-1 text-sm font-semibold text-gray-900">{t('pushFcm')}</h4>
        <p className="text-sm text-gray-600">
          {ready
            ? t('pushReady')
            : isWebPushConfigured()
              ? t('pushSetup')
              : t('pushSetup')}
        </p>
      </div>
      {categories && Object.keys(categories).length > 0 && (
        <div className="space-y-3">
          {Object.entries(categories)
            .filter(([key]) => key !== 'security_enabled')
            .map(([key, on]) => {
            const [label, desc] = LABELS[key] || [key, ''];
            return (
              <div
                key={key}
                className="flex items-center justify-between gap-4 rounded-lg border border-gray-100 bg-gray-50/50 px-4 py-3"
              >
                <div>
                  <div className="font-medium text-gray-900">{label}</div>
                  {desc ? <div className="text-sm text-gray-600">{desc}</div> : null}
                </div>
                <input
                  type="checkbox"
                  className="form-check"
                  checked={on === true}
                  disabled={busy}
                  onChange={(e) => toggle(key, e.target.checked)}
                />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
